export default __webpack_public_path__ + "static/media/blog.e2cb2c22.png";